var _Filters;
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { isEmpty } from 'lodash';
import { PropertyStatus } from '@domain-group/fe-allhomes-library/lib/node';
import { resolveLocalityFromMap } from '../locality/locality-resolver';
import { isA } from '../utils/testing';
import { PriceFilter } from './filters/price';
import { BedsFilter } from './filters/bedrooms';
import { BathroomsFilter } from './filters/bathrooms';
import { ParkingFilter } from './filters/parking';
import { FloorAreaFilter } from './filters/floor-area';
import { BlockSizeFilter } from './filters/block-size';
import { AvailabilityFilter } from './filters/availability';
import { OnlyWithPriceFilter } from './filters/only-with-price';
import { OnlyWithEventsFilter } from './filters/only-with-events';
import { PropertyTypesFilter } from './filters/property-types';
import { PropertyStatusFilter } from './filters/property-status';
import { SaleMethodsFilter } from './filters/sale-methods';
import { ListingFeaturesFilter } from './filters/listing-features';
import { ListedPropertyTypesFilter } from './filters/listed-property-types';
import { BadgesFilter } from './filters/badges';
import { ListedDateFilter } from './filters/listed-date';
import { KeywordsFilter } from './filters/keywords';
import { Localities } from './fields/localities';
import { Bounds } from './fields/bounds';
import { FilterTypes } from './filters/filter-type';
import { parseSearchOptions } from './search-options';
var FilterLocationTypes = ['localities', 'bounds'];
var localityResolver = function localityResolver(localityMap) {
  var withoutMissing = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return values => values.map(each => resolveLocalityFromMap(each.type, each.id || each.slug, localityMap) || each).filter(each => !withoutMissing || 'name' in each);
};
export class Filters {
  constructor(optionsOrListingType, valuesParam) {
    _defineProperty(this, "searchOptions", void 0);
    _defineProperty(this, "price", void 0);
    _defineProperty(this, "beds", void 0);
    _defineProperty(this, "baths", void 0);
    _defineProperty(this, "parking", void 0);
    _defineProperty(this, "floorArea", void 0);
    _defineProperty(this, "blockSize", void 0);
    _defineProperty(this, "availability", void 0);
    _defineProperty(this, "onlyWithPrice", void 0);
    _defineProperty(this, "onlyWithEvents", void 0);
    _defineProperty(this, "propertyTypes", void 0);
    _defineProperty(this, "propertyStatus", void 0);
    _defineProperty(this, "saleMethods", void 0);
    _defineProperty(this, "listingFeatures", void 0);
    _defineProperty(this, "listedPropertyTypes", void 0);
    _defineProperty(this, "badges", void 0);
    _defineProperty(this, "listedDate", void 0);
    _defineProperty(this, "keywords", void 0);
    _defineProperty(this, "bounds", void 0);
    _defineProperty(this, "localities", void 0);
    this.searchOptions = parseSearchOptions(optionsOrListingType);
    var values = Filters.isInstance(valuesParam) ? valuesParam.getValues() : valuesParam;
    this.price = new PriceFilter(this.searchOptions, values === null || values === void 0 ? void 0 : values.price);
    this.beds = new BedsFilter(this.searchOptions, values === null || values === void 0 ? void 0 : values.beds);
    this.baths = new BathroomsFilter(this.searchOptions, values === null || values === void 0 ? void 0 : values.baths);
    this.parking = new ParkingFilter(this.searchOptions, values === null || values === void 0 ? void 0 : values.parking);
    this.floorArea = new FloorAreaFilter(this.searchOptions, values === null || values === void 0 ? void 0 : values.floorArea);
    this.blockSize = new BlockSizeFilter(this.searchOptions, values === null || values === void 0 ? void 0 : values.blockSize);
    this.availability = new AvailabilityFilter(this.searchOptions, values === null || values === void 0 ? void 0 : values.availability);
    this.listedDate = new ListedDateFilter(this.searchOptions, values === null || values === void 0 ? void 0 : values.listedDate);
    this.keywords = new KeywordsFilter(this.searchOptions, values === null || values === void 0 ? void 0 : values.keywords);
    this.onlyWithPrice = new OnlyWithPriceFilter(this.searchOptions, values === null || values === void 0 ? void 0 : values.onlyWithPrice);
    this.onlyWithEvents = new OnlyWithEventsFilter(this.searchOptions, values === null || values === void 0 ? void 0 : values.onlyWithEvents);
    this.propertyTypes = new PropertyTypesFilter(this.searchOptions, values === null || values === void 0 ? void 0 : values.propertyTypes);
    this.propertyStatus = new PropertyStatusFilter(this.searchOptions, values === null || values === void 0 ? void 0 : values.propertyStatus);
    this.saleMethods = new SaleMethodsFilter(this.searchOptions, values === null || values === void 0 ? void 0 : values.saleMethods);
    this.listingFeatures = new ListingFeaturesFilter(this.searchOptions, values === null || values === void 0 ? void 0 : values.listingFeatures);
    this.listedPropertyTypes = new ListedPropertyTypesFilter(this.searchOptions, values === null || values === void 0 ? void 0 : values.listedPropertyTypes);
    this.badges = new BadgesFilter(this.searchOptions, values === null || values === void 0 ? void 0 : values.badges);
    this.bounds = new Bounds(this.searchOptions, values === null || values === void 0 ? void 0 : values.bounds);
    this.localities = new Localities(this.searchOptions, values === null || values === void 0 ? void 0 : values.localities);
  }
  get listingType() {
    return this.searchOptions.listingType;
  }
  get searchType() {
    return this.searchOptions.searchType;
  }
  cloneWith() {
    for (var _len = arguments.length, newValues = new Array(_len), _key = 0; _key < _len; _key++) {
      newValues[_key] = arguments[_key];
    }
    return new Filters(this.searchOptions, Object.assign({}, this.getValues(), ...newValues));
  }
  cloneWithLocalities(localities) {
    return this.cloneWith({
      bounds: undefined,
      localities: [...(localities || [])]
    });
  }
  getLocalities() {
    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return this.bounds.value ? [] : this.localities.byType(type);
  }
  getBounds() {
    return this.bounds.value;
  }
  getSingleLocality() {
    return this.localities.getSingleValue();
  }
  resolveLocalities(localityMap) {
    var removeMissing = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var resolved = localityResolver(localityMap, removeMissing);
    this.localities = new Localities(this.searchOptions, resolved(this.localities.value));
  }
  isLocationEmpty() {
    return this.localities.isEmpty() && this.bounds.isEmpty();
  }
  isSold() {
    var _this$propertyStatus;
    return Boolean((_this$propertyStatus = this.propertyStatus) === null || _this$propertyStatus === void 0 ? void 0 : _this$propertyStatus.hasOnlyValue(PropertyStatus.SOLD.name));
  }
  isRented() {
    var _this$propertyStatus2;
    return Boolean((_this$propertyStatus2 = this.propertyStatus) === null || _this$propertyStatus2 === void 0 ? void 0 : _this$propertyStatus2.hasOnlyValue(PropertyStatus.RENTED.name));
  }
  isDefault() {
    return this.localities.isDefault() && this.bounds.isDefault() && this.availableFilters().every(filterKey => {
      var _this$filterKey, _this$filterKey$isDef;
      return (_this$filterKey = this[filterKey]) === null || _this$filterKey === void 0 ? void 0 : (_this$filterKey$isDef = _this$filterKey.isDefault) === null || _this$filterKey$isDef === void 0 ? void 0 : _this$filterKey$isDef.call(_this$filterKey);
    });
  }
  availableFilters() {
    return FilterTypes.filter(filter => this[filter].isAvailable());
  }
  available() {
    return this.availableFilters();
  }
  getValues() {
    return Object.fromEntries([...this.availableFilters().map(filterKey => [filterKey, this[filterKey].value]), ['localities', this.localities.value], ['bounds', this.bounds.value]]);
  }
  getFilterUrlParameters() {
    return this.availableFilters().map(filter => this[filter].toUrlParameters()).flat().filter(each => each != null);
  }
  toUrlParameters() {
    return [...this.localities.toUrlParameters(), ...this.getFilterUrlParameters(), ...this.bounds.toUrlParameters()].filter(each => each && Object.values(each)[0] != null);
  }
  getLocation() {
    return _objectSpread({}, isEmpty(this.getBounds()) ? !isEmpty(this.localities) && {
      localities: this.localities.getMinimalIdentifiers()
    } : {
      bounds: this.getBounds()
    });
  }
  toQueryObject() {
    var bounds = this.bounds.getCondensedValue();
    return Object.fromEntries([...this.available().map(filter => [filter, this[filter].getCondensedValue()]), bounds ? ['bounds', bounds] : ['localities', this.localities.getCondensedValue()]].filter(_ref => {
      var _ref2 = _slicedToArray(_ref, 2),
        value = _ref2[1];
      return value != null;
    }));
  }
  isFilters() {
    return true;
  }
  static isInstance(value) {
    return isA(value, 'Filters');
  }
}
_Filters = Filters;
_defineProperty(Filters, "valuesOf", obj => _Filters.isInstance(obj) ? obj.getValues() : obj || {});
_defineProperty(Filters, "fromUrlParameters", function (searchOptionsOrListingType, q) {
  var _ListedDateFilter$fro, _PropertyTypesFilter$, _OnlyWithPriceFilter$, _PriceFilter$fromUrlP, _BedsFilter$fromUrlPa, _BathroomsFilter$from, _ParkingFilter$fromUr, _FloorAreaFilter$from, _BlockSizeFilter$from, _KeywordsFilter$fromU, _PropertyStatusFilter, _SaleMethodsFilter$fr, _ListedPropertyTypesF, _AvailabilityFilter$f, _ListingFeaturesFilte, _BadgesFilter$fromUrl, _OnlyWithEventsFilter, _Localities$fromUrlPa, _Bounds$fromUrlParame;
  var p = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var searchOptions = parseSearchOptions(searchOptionsOrListingType);
  return new _Filters(searchOptions, {
    listedDate: (_ListedDateFilter$fro = ListedDateFilter.fromUrlParameters(searchOptions, q)) === null || _ListedDateFilter$fro === void 0 ? void 0 : _ListedDateFilter$fro.value,
    propertyTypes: (_PropertyTypesFilter$ = PropertyTypesFilter.fromUrlParameters(searchOptions, q, p)) === null || _PropertyTypesFilter$ === void 0 ? void 0 : _PropertyTypesFilter$.value,
    onlyWithPrice: (_OnlyWithPriceFilter$ = OnlyWithPriceFilter.fromUrlParameters(searchOptions, q)) === null || _OnlyWithPriceFilter$ === void 0 ? void 0 : _OnlyWithPriceFilter$.value,
    price: (_PriceFilter$fromUrlP = PriceFilter.fromUrlParameters(searchOptions, q)) === null || _PriceFilter$fromUrlP === void 0 ? void 0 : _PriceFilter$fromUrlP.value,
    beds: (_BedsFilter$fromUrlPa = BedsFilter.fromUrlParameters(searchOptions, q, p)) === null || _BedsFilter$fromUrlPa === void 0 ? void 0 : _BedsFilter$fromUrlPa.value,
    baths: (_BathroomsFilter$from = BathroomsFilter.fromUrlParameters(searchOptions, q)) === null || _BathroomsFilter$from === void 0 ? void 0 : _BathroomsFilter$from.value,
    parking: (_ParkingFilter$fromUr = ParkingFilter.fromUrlParameters(searchOptions, q)) === null || _ParkingFilter$fromUr === void 0 ? void 0 : _ParkingFilter$fromUr.value,
    floorArea: (_FloorAreaFilter$from = FloorAreaFilter.fromUrlParameters(searchOptions, q)) === null || _FloorAreaFilter$from === void 0 ? void 0 : _FloorAreaFilter$from.value,
    blockSize: (_BlockSizeFilter$from = BlockSizeFilter.fromUrlParameters(searchOptions, q)) === null || _BlockSizeFilter$from === void 0 ? void 0 : _BlockSizeFilter$from.value,
    keywords: (_KeywordsFilter$fromU = KeywordsFilter.fromUrlParameters(searchOptions, q)) === null || _KeywordsFilter$fromU === void 0 ? void 0 : _KeywordsFilter$fromU.value,
    propertyStatus: (_PropertyStatusFilter = PropertyStatusFilter.fromUrlParameters(searchOptions, q, p)) === null || _PropertyStatusFilter === void 0 ? void 0 : _PropertyStatusFilter.value,
    saleMethods: (_SaleMethodsFilter$fr = SaleMethodsFilter.fromUrlParameters(searchOptions, q)) === null || _SaleMethodsFilter$fr === void 0 ? void 0 : _SaleMethodsFilter$fr.value,
    listedPropertyTypes: (_ListedPropertyTypesF = ListedPropertyTypesFilter.fromUrlParameters(searchOptions, q)) === null || _ListedPropertyTypesF === void 0 ? void 0 : _ListedPropertyTypesF.value,
    availability: (_AvailabilityFilter$f = AvailabilityFilter.fromUrlParameters(searchOptions, q)) === null || _AvailabilityFilter$f === void 0 ? void 0 : _AvailabilityFilter$f.value,
    listingFeatures: (_ListingFeaturesFilte = ListingFeaturesFilter.fromUrlParameters(searchOptions, q)) === null || _ListingFeaturesFilte === void 0 ? void 0 : _ListingFeaturesFilte.value,
    badges: (_BadgesFilter$fromUrl = BadgesFilter.fromUrlParameters(searchOptions, q)) === null || _BadgesFilter$fromUrl === void 0 ? void 0 : _BadgesFilter$fromUrl.value,
    onlyWithEvents: (_OnlyWithEventsFilter = OnlyWithEventsFilter.fromUrlParameters(searchOptions, q)) === null || _OnlyWithEventsFilter === void 0 ? void 0 : _OnlyWithEventsFilter.value,
    localities: (_Localities$fromUrlPa = Localities.fromUrlParameters(searchOptions, q, p)) === null || _Localities$fromUrlPa === void 0 ? void 0 : _Localities$fromUrlPa.value,
    bounds: (_Bounds$fromUrlParame = Bounds.fromUrlParameters(searchOptions, q)) === null || _Bounds$fromUrlParame === void 0 ? void 0 : _Bounds$fromUrlParame.value
  });
});
_defineProperty(Filters, "fromQueryObject", (searchOptionsOrListingType, queryObject) => {
  var searchOptions = parseSearchOptions(searchOptionsOrListingType);
  var filters = queryObject.filters;
  return new _Filters(searchOptions, _Filters.isInstance(filters) ? filters : _objectSpread(_objectSpread({}, filters), {}, {
    localities: Localities.fromQueryObject(searchOptions, queryObject).value
  }));
});